import { DocumentsEnum } from "@gtpl/shared-models/logistics";
import { UpdateDocumentUploadInfo } from "../dto/document-approval-update.dto";
import { DocumentsUploadDto } from "../dto/documents-upload.dto";
import { DocumentsApproval } from "../entities/documents-approval.entity";

export class DocumentsApprovalAdapter{

    public convertDtoToEntity(dto:UpdateDocumentUploadInfo):DocumentsApproval{
        const entity = new DocumentsApproval();
            if(dto.documentsApprovalId){
                entity.documentsApprovalId = dto.documentsApprovalId;
            }
            
        entity.saleOrderId = dto.saleOrderId;
        if(DocumentsEnum.CUSTOMS_INVOICE == dto.documentName){
            entity.customsInvoiceUploaded = dto.status;
        }

        if(DocumentsEnum.COMMON_INVOICE == dto.documentName){
            entity.commonInvoiceUploaded = dto.status;
        }

        if(DocumentsEnum.COMMERCIAL_PACKING_LIST == dto.documentName){
            entity.commercialPackingListUploaded = dto.status;
        }

        if(DocumentsEnum.COMMERCIAL_INVOICE == dto.documentName){
            entity.commercialInvoiceUploaded = dto.status;
        }

        if(DocumentsEnum.PLANT_PACKING_LIST == dto.documentName){
            entity.plantPackingListUploaded = dto.status;
        }

        if(DocumentsEnum.PLANT_INVOICE == dto.documentName){
            entity.plantInvoiceUploaded = dto.status;
        }

        if(DocumentsEnum.SHIPMENT_INSTRUCTIONS == dto.documentName){
            entity.shipmentInstructionsUploaded = dto.status;
        }

        if(DocumentsEnum.FORM_13 == dto.documentName){
            entity.formsThirteenUploaded = dto.status;
        }

        if(DocumentsEnum.BL_DRAFT == dto.documentName){
            entity.bLDraftUploaded = dto.status;
        }

        if(DocumentsEnum.FREIGHT_INVOICE == dto.documentName){
            entity.freightInvoiceUploaded = dto.status;
        }

        if(DocumentsEnum.OBL == dto.documentName){
            entity.oblUploaded = dto.status;
        }

        if(DocumentsEnum.ISF_Worksheet == dto.documentName){
            entity.iSFWorksheetUploaded = dto.status;
        }

        if(DocumentsEnum.SIMP == dto.documentName){
            entity.sIMPUploaded = dto.status;
        }

        if(DocumentsEnum.CERTIFICATE_OF_ORIGIN == dto.documentName){
            entity.certificateOfOriginUploaded = dto.status;
        }

        if(DocumentsEnum.DECLARATION_OF_SHRIMP == dto.documentName){
            entity.declarationOfShrimpUploaded = dto.status;
        }
        if(DocumentsEnum.HEALTH_CERTIFICATE == dto.documentName){
            entity.healthCertificateUploaded = dto.status;
        }
        if(DocumentsEnum.SURVEY_REPORT == dto.documentName){
            entity.surveyReportUploaded = dto.status;
        }


        // entity.approverOneStatus = dto.approver1Status;
        // entity.approverTwoStatus = dto.approver2Status;

        return entity;
    }

    public convertApproverDtoToEntity(docDto:DocumentsUploadDto):DocumentsApproval{
        const entity = new DocumentsApproval();
        entity.documentsApprovalId = docDto.documentsApprovalId,
        entity.saleOrderId = docDto.saleOrderId,
        entity.customsInvoiceUploaded = docDto.customsInvoiceUploaded,
        entity.commonInvoiceUploaded = docDto.commonInvoiceUploaded,
        entity.commercialPackingListUploaded = docDto.commercialPackingListUploaded,
        entity.commercialInvoiceUploaded = docDto.commercialInvoiceUploaded,
        entity.plantPackingListUploaded = docDto.plantPackingListUploaded,
        entity.plantInvoiceUploaded = docDto.plantInvoiceUploaded,
        entity.shipmentInstructionsUploaded = docDto.shipmentInstructionsUploaded,
        entity.formsThirteenUploaded = docDto.form13sUploaded,
        entity.bLDraftUploaded = docDto.bLDraftUploaded,
        entity.freightInvoiceUploaded = docDto.freightInvoiceUploaded,
        entity.oblUploaded = docDto.oblUploaded,
        entity.iSFWorksheetUploaded = docDto.iSFWorksheetUploaded,
        entity.sIMPUploaded = docDto.sIMPUploaded,
        entity.certificateOfOriginUploaded = docDto.certificateOfOriginUploaded,
        entity.declarationOfShrimpUploaded = docDto.declarationOfShrimpUploaded,
        entity.approverOneStatus = docDto.approverOneStatusUploaded,
        entity.approverTwoStatus = docDto.approverTwoStatusUploaded,
        entity.approverOne = docDto.approverOne,
        entity.approverTwo = docDto.approverTwo
        return entity
    }
}